<template>
  <c-modal class-name="profile-tab-modal" :active="displayModal" :title="title" @close="close">
    <form @submit.prevent="submit">
      <c-input
        v-model="name"
        floating-label="Наименование вкладки"
        :max-length="255"
        :required-mark="true"
        :required="isSubmitted && nameError"
        :required-condition="isSubmitted && nameError"
        :class="{ 'is-invalid': isSubmitted && nameError }"
      />
    </form>

    <template #actions>
      <c-button size="large" label="Отменить" @click="close" />
      <c-button label="Сохранить" color="primary" size="large" :disabled="pending" :pending="pending" @click="submit" />
    </template>
  </c-modal>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import CModal from "@/components/scrollable-modal";
import { REQUIRED_ERROR } from "@/constants/errorFieldValues";

export default {
  components: {
    CInput,
    CButton,
    CModal,
  },
  props: ["profileId", "profileSection"],
  data() {
    return {
      displayModal: false,
      tab: null,
      isSubmitted: false,
      pending: false,
      name: "",
    };
  },
  computed: {
    title() {
      return this.tab ? "Редактировать вкладку" : "Создать вкладку";
    },
    nameError() {
      return this.name.trim() ? false : REQUIRED_ERROR;
    },
    isValid() {
      return !this.nameError;
    },
  },

  methods: {
    open(tab) {
      if (tab) this.setData(tab);
      this.displayModal = true;
    },

    setData(tab) {
      this.tab = tab;
      this.name = tab.name;
    },

    close() {
      this.displayModal = false;
      this.reset();
      this.$emit("close");
    },

    reset() {
      this.isSubmitted = false;
      this.pending = false;
      this.tab = null;
      this.name = "";
    },

    getParams() {
      const params = {
        name: this.name,
        profileSection: this.profileSection,
        profileId: this.profileId,
      };
      if (this.tab) {
        params.id = this.tab.id;
      }
      return params;
    },

    submit() {
      this.isSubmitted = true;
      if (!this.isValid) {
        return;
      }

      this.pending = true;

      const editMode = !!this.tab;
      const action = editMode ? "profile/updateTab" : "profile/createTab";

      this.$store
        .dispatch(action, this.getParams())
        .then((response) => {
          this.pending = false;
          if (response.success) {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: editMode
                  ? `Вкладка <b>${this.name}</b> успешно изменена`
                  : `Вкладка <b>${this.name}</b> успешно добавлена`,
              },
            });

            this.$emit(editMode ? "updated" : "created", response.model);
            this.close();
          }
        })
        .catch(() => {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: "Произошла ошибка. Попробуйте ещё раз.",
            },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.is-invalid {
  padding-bottom: 25px;
}
</style>

<style>
.profile-tab-modal {
  max-width: 590px !important;
}
</style>
